import { isBrowser as n } from "./commonUtils.js";
function o(t) {
  var e;
  return !t || !n() ? !1 : /^(https?:\/\/)/.test(t) ? new URL(t).hostname !== ((e = window == null ? void 0 : window.location) == null ? void 0 : e.hostname) : !1;
}
function a(t) {
  return o(t) ? "nofollow" : void 0;
}
export {
  o as externalUrlChecker,
  a as getRelAttributeAccordingToUrl
};
